import { css } from '@emotion/css'

export const POPOVER_STYLES = css(`
  &.cf-popover-content {
    z-index: 1112;
  }
`)
